module.exports = __webpack_public_path__ + "static/media/java.fcc95a9f.svg";